import { useEffect } from 'react';
import { useSelector } from 'react-redux';

/**
 * Theme Provider Hook
 * Redux'taki theme state'ine göre <html> elementine 'dark' class'ı ekler/çıkarır.
 * Bu sayede CSS variables otomatik olarak dark/light değerlerine geçiş yapar.
 * 
 * @returns {string} Mevcut tema ('light' | 'dark')
 */
export function useThemeProvider() {
    const theme = useSelector((state) => state.ui.theme);

    useEffect(() => {
        const root = document.documentElement;

        if (theme === 'dark') {
            root.classList.add('dark');
        } else {
            root.classList.remove('dark');
        }
    }, [theme]);

    return theme;
}

export default useThemeProvider;
